import { useNavigate, useParams } from "react-router";
import ProfileDropdown from "../components/ProfileDropDown";
import { useEffect, useState } from "react";
import { useApp } from "../Context";

export default function Header() {
    const { restaurant } = useParams();
    const navigate = useNavigate();
    const {getCfg, table, setTable} = useApp();

    const [name, setName] = useState(() => {
        return getCfg().text
    });

    useEffect(() => {
        if (!name) {
            getCfg().then((item) => {
                setName(item.text);
            });
        }
    }, [name]);

    return (
        <div
            className="d-flex align-items-center justify-content-between px-3 py-2"
            style={{
                height: "50px",
                position: "fixed",
                top: 0,
                width: "100%",
                maxWidth: "500px",
                zIndex: 1050,
                backgroundColor: "white",
            }}
        >
            {/* Table Number Badge (Left Side) */}
            <div className="d-flex align-items-center" style={{ minWidth: "90px" }}>
                    {table &&
                    <span
                        className="btn btn-warning btn-sm rounded-pill fw-semibold px-3 py-1 shadow-sm"
                        onClick={() => {
                            //navigate(0)
                            setTable(null)
                        }}
                    >
                        {table? `Bord ${table}`: "Inget bord"}
                    </span>
                    }
                
            </div>

            {/* Centered Restaurant Name */}
            <h5 className="m-0 text-center flex-grow-1 fw-bold text-dark" onClick={()=>navigate("order")}>
                {name ?? "Laddar... 1"}
            </h5>

            {/* Profile Icon (Right Side) */}
            <div className="d-flex justify-content-end align-items-center" style={{ minWidth: "70px" }}>
                <ProfileDropdown />
            </div>
        </div>
    );
}
